import { Ref, ref, computed } from "@vue/composition-api";
import { EntityCounter, InvEntityType, Subject } from "./model";
import * as entities_handler from "../entities";
import { memoize_by } from "@/fp";
import { TimeFrameOption } from "@/common/state/models";

const _entities_counters: Ref<Record<InvEntityType, EntityCounter>> = ref({});

const displayed_entity_counters = computed(() =>
  Object.entries(_entities_counters.value).map(([type, item]) => {
    return {
      type,
      ...item,
    };
  })
);

const _load_counters = memoize_by(
  (p: { subject: Subject; relative_time_frame: TimeFrameOption }) =>
    p.subject.id + p.relative_time_frame.displayName,
  async ({ subject, relative_time_frame }) => {
    return await entities_handler.get_entity_counters(
      subject,
      relative_time_frame
    );
  }
);

const load_counters = async (
  subject: Subject,
  relative_time_frame: TimeFrameOption
) => {
  _entities_counters.value = await _load_counters({
    subject,
    relative_time_frame,
  });
};

export const entity_counters = {
  load_counters,
  counters: displayed_entity_counters,
};
